import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { toast } from 'react-toastify';



const ProjectDeleteModal = ({ deleteProject, setDeleteProject, refetch }) => {


    const { name } = deleteProject;

    const handleProjectDelete = id => {
        const url = `https://stark-wildwood-35883.herokuapp.com/projects/${id}`;
        fetch(url, {
            method: "DELETE",
            headers: {
                'content-type': 'application/json',
            }
        })
            .then(res => res.json())
            .then(data => {
                if (data.deletedCount > 0) {
                    setDeleteProject(null)
                    refetch();
                    toast.success(`Deleted ${name} Successfully `);
                }
                else {
                    setDeleteProject(null)
                    toast.error(`Failed to delete ${name} `);
                }
            })

    }




    return (
        <div>
            <input type="checkbox" id="delete-Confirm-Modal" className="modal-toggle" />
            <div className="modal modal-bottom sm:modal-middle">
                <div className="modal-box">
                    <h3 className="font-bold text-lg text-red-400">Are you sure you want to Delete <span className='font-bold text-green-500 text-lg'>{deleteProject?.name}!!</span></h3>
                    <p className="py-4">If you are delete this item one time it will delete permanently.If you don't want to delete click cancel or If you sure to delete then click delete button!</p>
                    <div className="modal-action">
                        <button className='btn flex items-center border-0 bg-red-300 text-red-500' onClick={() => handleProjectDelete(deleteProject?._id)} >DELETE <FontAwesomeIcon className='ml-2' icon={faTrashCan}></FontAwesomeIcon></button>
                        <label htmlFor="delete-Confirm-Modal" className="btn">Cancel</label>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default ProjectDeleteModal;